<template>
    <div class="oak-popup-overlay" @click.stop="$emit('close')">
        <div class="oak-popup-box" :class="{'oak-popup-box--roomy': roomy}">
            <div class="oak-popup-box__body">
                <v-icon
                    v-if="icon"
                    :size="avatarSize"
                    :color="danger ? 'error' : 'white'"
                    style="flex: 0 0 auto;"
                >{{ icon }}</v-icon>
                <v-img
                    v-else
                    src='@/assets/pic/web/oak_avatar.png'
                    :max-width="avatarSize"
                    :max-height="avatarSize"
                    style="transform: scaleX(-1); flex: 0 0 auto;"
                />
                <div class="oak-popup-box__text" :class="{'error--text': danger}">
                    <div v-if="skill" class="oak-popup-box__title">{{ skill.name }}:</div>
                    <div v-else-if="title" class="oak-popup-box__title">{{ title }}</div>
                    <span>{{ skill ? skill.description : text }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // Sdilena tmava poloprusvitna popup bublina bez krizku (zavira se klikem
    // kamkoliv) - puvodne jen pro popis Oak skillu (TrainerDetail.vue,
    // TrainerList.vue - `skill` prop), rozsirena o obecny icon+title+text
    // rezim pro libovolnou kratkou informacni/varovnou hlasku (trade
    // hlasky - viz TradeHub.vue, Stones.vue).
    export default {
        name: 'OakSkillHintPopup',
        props: {
            skill: {type: Object, default: undefined},
            title: {type: String, default: undefined},
            text: {type: String, default: undefined},
            icon: {type: String, default: undefined},
            avatarSize: {type: [Number, String], default: 60},
            danger: {type: Boolean, default: false},
            roomy: {type: Boolean, default: false},
        },
    }
</script>

<style scoped>
.oak-popup-overlay {
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: rgba(0, 0, 0, .35);
    cursor: pointer;
}

.oak-popup-box {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: min(90vw, 420px);
    background: rgba(0, 0, 0, .75);
    backdrop-filter: blur(2px);
    color: #fff;
    padding: 18px 20px;
    border-radius: 12px;
    font-size: 1.1em;
    text-align: left;
    box-shadow: 0 8px 24px rgba(0, 0, 0, .4);
    /* .oak-popup-overlay je position:fixed, ale porad DOM potomek mista, kde se otevre - dedi CSS vlastnosti (napr. text-no-wrap z FightReport.vue karty), bez tohoto resetu by dlouhy text tise vytekal mimo box bez ohledu na to, kam bude v budoucnu vlozen. */
    white-space: normal;
}

.oak-popup-box--roomy {
    max-width: min(90vw, 480px);
    padding: 26px 28px;
    font-size: 1.2em;
}

.oak-popup-box__body {
    display: flex;
    align-items: center;
    gap: 12px;
}

.oak-popup-box__text {
    display: flex;
    flex-direction: column;
    gap: 4px;
    /* Flex polozka bez explicitni sirky ma default min-width:auto - bez tohoto by dlouhy text vyjizdel mimo .oak-popup-box (max-width) misto zalomeni na vic radku. */
    min-width: 0;
}

.oak-popup-box__title {
    font-weight: 700;
    font-size: 1.15em;
}
</style>
